// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3jDhy","fileBtn":"File_fileBtn__3nZSw","closeBtn":"File_closeBtn__2aSht","fileSelected":"File_fileSelected__1zesQ","disabled":"File_disabled__l6Nq7"};